import { Component } from '@angular/core';
import { Divider } from 'primeng/divider';

@Component({
  selector: 'app-edit-menu',
  imports: [Divider],
  templateUrl: '../ui/edit-menu.component.html'
})
export class EditMenuComponent {

}
